import React from 'react';
import { ArrowRight, RotateCcw } from 'react-feather';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { UNIT_TYPE } from 'constants/constants';
import { useUnit } from 'hooks/units/index';
import ButtonDropdownCustom from 'components/CustomButton/ButtonDropdownCustom';
import { useSelector } from 'react-redux';
import { getColor, getColorText } from 'store/settings';

const ButtonNotPassed = ({
  onReAttempt,
  onResetUnit,
  onRouteContinue,
  isLoading,
  isNextUnit,
}) => {
  const unitSelected = useUnit();
  const config = unitSelected?.config;
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const renderTextTryAgain = () => {
    if (config?.repetitions || unitSelected?.type === UNIT_TYPE.SCORM) {
      return '. Click to try again.';
    }
    return '';
  };

  if (config?.completion?.reAttempt && config?.repetitions && !isNextUnit) {
    return (
      <ButtonDropdownCustom
        action={onReAttempt}
        title={`You did not pass. Click to Reattempt`}
        actions={[
          {
            text: ' You did not pass. Click to try again.',
            action: onResetUnit,
            iconLeft: <RotateCcw size={15} className="mr-05" />,
          },
        ]}
        disabled={isLoading}
      />
    );
  } else if (!isNextUnit) {
    return (
      <button
        onClick={onResetUnit}
        disabled={isLoading}
        className="btn-bg-color"
        style={{
          backgroundColor: `${colorStatus}`,
          color: `${colorTextStatus}`,
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = 'white';
          e.target.style.borderColor = colorStatus;
          e.target.style.color = colorStatus;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = colorStatus;
          e.target.style.color = colorTextStatus;
        }}
      >
        You did not pass
        {renderTextTryAgain()}
      </button>
    );
  }
  return config?.completion?.reAttempt && config?.repetitions ? (
    <ButtonDropdownCustom
      action={onReAttempt}
      title={`You did not pass. Click to Reattempt`}
      actions={[
        {
          text: ' You did not pass. Click to try again.',
          action: onResetUnit,
          iconLeft: <RotateCcw size={15} className="mr-05" />,
        },
        {
          text: 'Next unit',
          action: onRouteContinue,
          iconLeft: <ArrowRight size={15} className="mr-05" />,
        },
      ]}
      disabled={isLoading}
    />
  ) : (
    <ButtonDropdownCustom
      action={onResetUnit}
      title={`You did not pass${renderTextTryAgain()}`}
      actions={[
        {
          text: 'Next unit',
          action: onRouteContinue,
          iconLeft: <ArrowRight size={15} className="mr-05" />,
        },
      ]}
      disabled={isLoading}
    />
  );
};

ButtonNotPassed.propTypes = {
  onResetUnit: PropTypes.func.isRequired,
  onRouteContinue: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isNextUnit: PropTypes.bool.isRequired,
};

export default ButtonNotPassed;
